export class UcElementBlockedEvent extends Event {

  ucId: string
  ucService: string
  useBasicThumbnail: boolean

  constructor (ucId: string, ucService: string, useBasicThumbnail?: boolean) {
    super('UcElementBlockedEvent')
    this.ucId = ucId
    this.ucService = ucService
    this.useBasicThumbnail = useBasicThumbnail || false
  }
}
